// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import EventOccurenceModel from '../../model/event-occurence-model';
import EventOccurenceDTO from '../dto/event-occurence-dto';
import dtoSchema from '../schemas/event-occurence-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class EventOccurenceModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<EventOccurenceDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.startDate = data.startDate;
      this.endDate = data.endDate;
      this.eventExecution = data.eventExecution;
      this.room = data.room ?? undefined;
      this.company = data.company ?? undefined;
      this.street = data.street ?? undefined;
      this.city = data.city ?? undefined;
      this.postCode = data.postCode ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {date-time}
  */
  startDate?: string;
  /**
  * @type {date-time}
  */
  endDate?: string;
  /**
  * @type {int32}
  */
  eventExecution?: 0 | 1 | 2 | 3; // EventExecutionDTO
  /**
  */
  room?: string;
  /**
  */
  company?: string;
  /**
  */
  street?: string;
  /**
  */
  city?: string;
  /**
  */
  postCode?: string;

  static toModel(dto: DeepPartial<EventOccurenceDTO>): EventOccurenceModel;
  static toModel(dto: DeepPartial<EventOccurenceDTO> | undefined | null): EventOccurenceModel | undefined;
  static toModel(dto: DeepPartial<EventOccurenceDTO> | undefined | null): EventOccurenceModel | undefined {
    return dto ? new EventOccurenceModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<EventOccurenceModel> | EventOccurenceModel): EventOccurenceDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      startDate: unwrapped.startDate,
      endDate: unwrapped.endDate,
      eventExecution: unwrapped.eventExecution,
      room: unwrapped.room,
      company: unwrapped.company,
      street: unwrapped.street,
      city: unwrapped.city,
      postCode: unwrapped.postCode,
    } as EventOccurenceDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for EventOccurenceModel, can not map to EventOccurenceDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
